<script setup lang="ts">
import { Toast } from 'primevue';
</script>

<template>
  <Toast
    class="w-[90vw]! md:right-0! md:left-[unset]! md:w-[30rem]!"
    position="top-center"
    :pt="{
      messageIcon: ({ props: toastProps }) => ({
        class: [
          {
            'is-success': toastProps.message.severity == 'success',
            'is-info': toastProps.message.severity == 'info',
          },
        ],
      }),
    }"
  >
    <template #messageicon="{ class: className }">
      <v-icon v-if="className.includes('is-success')" name="custom-table-2" />
      <v-icon
        v-if="className.includes('is-info')"
        name="custom-notification-bing"
        fill="none"
      />
      <v-icon v-else name="custom-bag-2" />
    </template>
  </Toast>
</template>

<style lang="css">
.p-toast-message-info {
  background: --alpha(var(--color-white) / 70%) !important;
  border-color: --alpha(var(--color-grand-text) / 60%) !important;
  color: var(--color-grand-text) !important;
  border-radius: 1rem !important;
}
.p-toast-message-info .p-toast-message-content {
  color: var(--color-grand-text) !important;
}
.p-toast-message-info .p-toast-message-text {
  color: var(--color-grand-text) !important;
}
.p-toast-message-info .p-toast-detail {
  color: var(--color-secondary-text) !important;
  font-weight: 400;
}
.p-toast-message-info .p-toast-close-button {
  border-color: var(--color-grand-text) !important;
}
</style>
